
export enum SharingStatus {
	PRIVATE = 'PRIVATE',
	SHARED = 'SHARED',
	PUBLIC = 'PUBLIC'
}
